import { render } from "./Terreni.vue?vue&type=template&id=9fad332c"
import script from "./Terreni.vue?vue&type=script&lang=js"
export * from "./Terreni.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francescoscialacqua/Sviluppo/emmet.client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__